require('./brokerTransferValuesSidebar.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const moment = require('moment');
// @ commons
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKModal = require('components/commons/OKModal/OKModal');
// @ helpers
const DateHelper = require('utilities/dateHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;
// @ constants
const { DATETIME_FORMAT_ES } = require('constants/index');
// @ consntans
const {
    BROKER_TRANSFER_VALUES_TYPE_TOTAL,
    BROKER_TRANSFER_VALUES_TYPE_PARTIAL,
    CHARGE_ACCOUNT_PREFIX,
    FIRST_STEP

} = require('constants/index');

class BrokerTransferValuesSidebar extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false
        };

        this.buildDetailsModal = this.buildDetailsModal.bind(this);
        this.handleSeeTransferDetailsClick = this.handleSeeTransferDetailsClick.bind(this);
    }

    buildAccountBlock({ postfix, immContract }) {
        const key = `blockContract${immContract.get('walletNumber')}`;
        const title = `broker-transferValuesSidebarSecondStepAccount${postfix}`;
        const contractAccount = immContract.get('contractAccount');
        const plainAmountObject = getPlainAmountObject(immContract.get('associatedAccountBalance'));
        const controlDigit = contractAccount.get('controlDigit');
        const accountNumber = contractAccount.get('accountNumber');
        const valueContractNumber = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${accountNumber}`;

        return (
            <section key={key} className="broker-transfer-values-sidebar__account">
                <FormattedText value={title} />
                <div className="broker-transfer-values-sidebar__account-title">
                    {immContract.get('walletAccountType')}
                </div>
                <div className="broker-transfer-values-sidebar__account-info">
                    <div className="broker-transfer-values-sidebar__account-number">
                        {contractAccount.get('entityCode')} {contractAccount.get('officeCode')}{' '}
                        {valueContractNumber}
                    </div>
                    <div className="broker-transfer-values-sidebar__titular">
                        <FormattedText
                            value="broker-transferValuesSidebarSecondStepFirstTitular"
                            className="broker-transfer-values-sidebar__label"
                        />
                        <span>
                            {immContract.get('firstTitular')} ({formatText(`interventionTypes-${immContract.get('firstTitularType')}`)})
                        </span>
                    </div>
                    <div className="broker-transfer-values-sidebar__account-associated">
                        <FormattedText
                            value="broker-transferValuesSidebarSecondStepAssociatedAccount"
                            className="broker-transfer-values-sidebar__label"
                        />
                        {immContract.get('associatedAccountAlias')}
                        <div>
                            <span className="broker-transfer-values-sidebar__label">
                                {immContract.get('associatedAccount')}
                            </span>
                            (
                            <FormattedText
                                value="broker-transferValuesSidebarSecondStepBalance"
                                className="broker-transfer-values-sidebar__label"
                            />
                            <OneLineSymbolAmount
                                amountObject={plainAmountObject}
                                language={getLanguage()}
                                amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                            />
                            )
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    buildDetailsModal() {
        const { immTransferValues, immContractValues } = this.props;
        const contractFrom = immTransferValues.getIn(['steps', 0, 'accountIdFrom']);
        const immContractFrom = immTransferValues.getIn(['steps', 0, 'accountsFromOptions', contractFrom]);

        if (!immContractFrom || !immContractValues.getIn([immContractFrom.get('walletNumber'), 'byOrder'])) {
            return;
        }

        const values = immContractValues
            .getIn([immContractFrom.get('walletNumber'), 'byOrder'])
            .map((valueId, index) => {
                const immValue = immContractValues.getIn([
                    immContractFrom.get('walletNumber'),
                    'byId',
                    valueId
                ]);

                const key = `modalBlockValues${valueId}-${index}`;
                const titles = immValue.get('titles');
                const titlesLabelPostfix = titles !== 1 ? 's' : '';
                const titlesLabel = `broker-transferValuesSidebarThirdStepTitle${titlesLabelPostfix}`;

                return (
                    <div key={key} className="broker-transfer-values-sidebar__value">
                        <div className="broker-transfer-values-sidebar__value-name">
                            {immValue.get('description')}
                        </div>
                        <div className="broker-transfer-values-sidebar__value-titles">
                            <FormattedText value={titlesLabel} injectedStrings={[titles]} />
                        </div>
                    </div>
                );
            });

        return (
            <OKModal
                content={values}
                isOpen={this.state.modalOpen}
                onCloseCallback={this.handleSeeTransferDetailsClick}
            />
        );
    }

    buildFirstStepSidebar() {
        const title = formatText('broker-transferValuesSidebarFirstStepTitle');
        const content = <FormattedText value="broker-transferValuesSidebarFirstStepMessage" />;

        return {
            title,
            content
        };
    }

    buildSecondStepSidebar() {
        const { immTransferValues } = this.props;
        const contractFrom = immTransferValues.getIn(['steps', 0, 'accountIdFrom']);
        const contractTo = immTransferValues.getIn(['steps', 0, 'accountIdTo']);
        const title = formatText('broker-transferValuesSidebarSecondStepTitle');
        let content;

        const immContractFrom = immTransferValues.getIn(['steps', 0, 'accountsFromOptions', contractFrom]);
        const immContractTo = immTransferValues.getIn([
            'steps',
            FIRST_STEP,
            'accountsToOptions',
            contractTo
        ]);

        content = [
            this.buildAccountBlock({
                postfix: 'From',
                immContract: immContractFrom
            }),
            this.buildAccountBlock({
                postfix: 'To',
                immContract: immContractTo
            }),
            this.buildTransferTypeBlock(immTransferValues)
        ];

        return {
            title,
            content
        };
    }

    buildSuccessInfoBlock() {
        const block = this.buildSecondStepSidebar();
        const content = this.buildTransferValuesBlock();
        const dateBlock = this.buildTransferValuesDateBlock();

        return [block.content, dateBlock, content];
    }

    buildThirdStepSidebar() {
        const block = this.buildSecondStepSidebar();
        const content = this.buildTransferValuesBlock();
        return {
            title: block.title,
            content: [block.content, content]
        };
    }

    buildTransferTypeBlock(immTransferValues) {
        let selected;

        if (immTransferValues.getIn(['steps', 1, BROKER_TRANSFER_VALUES_TYPE_TOTAL, 'selected'])) {
            selected = BROKER_TRANSFER_VALUES_TYPE_TOTAL;
        }

        if (
            immTransferValues.getIn(['steps', 1, BROKER_TRANSFER_VALUES_TYPE_PARTIAL, 'selected'])
        ) {
            selected = BROKER_TRANSFER_VALUES_TYPE_PARTIAL;
        }

        const transferType = `broker-transferValuesSidebarSecondStepTransferType${selected}`;

        return (
            <section>
                <FormattedText value="broker-transferValuesSidebarSecondStepTransferType" />
                <div className="broker-transfer-values-sidebar__transfer-type">
                    <FormattedText value={transferType} />
                </div>
            </section>
        );
    }

    buildTransferValuesBlock() {
        const { immTransferValues, immContractValues, success } = this.props;
        const contractFrom = immTransferValues.getIn(['steps', 0, 'accountIdFrom']);
        const immContractFrom = immTransferValues.getIn([
            'steps',
            0,
            'accountsFromOptions',
            contractFrom
        ]);

        let seeDetailsButton;

        if (!success) {
            seeDetailsButton = (
                <div>
                    <OKButton
                        modifier="link-complementary"
                        onClick={this.handleSeeTransferDetailsClick}
                    >
                        <FormattedText value="broker-transferValuesSeeDetails" />
                    </OKButton>
                </div>
            );
        }

        if (immTransferValues.getIn(['steps', 1, BROKER_TRANSFER_VALUES_TYPE_TOTAL, 'selected'])) {
            let totalTitles = 0;

            immContractValues
                .getIn([immContractFrom.get('walletNumber'), 'byOrder'])
                .forEach(id => {
                    const immValue = immContractValues.getIn([
                        immContractFrom.get('walletNumber'),
                        'byId',
                        id
                    ]);

                    totalTitles += immValue.get('titles');
                });

            const titlesLabelPostfix = totalTitles !== 1 ? 's' : '';
            const titlesLabel = `broker-transferValuesSidebarThirdStepTitle${titlesLabelPostfix}`;

            return (
                <section className="broker-transfer-values-sidebar__values-list">
                    <div className="broker-transfer-values-sidebar__values-list-title">
                        <FormattedText value="broker-transferValuesSidebarThirdStepValuesToTransfer" />
                    </div>
                    <div>
                        <p>
                            {formatText('broker-transferValuesSidebarSecondStepTransferAll')}
                        </p>
                        <p>
                            <span>
                                {
                                    immContractValues.getIn([
                                        immContractFrom.get('walletNumber'),
                                        'byOrder'
                                    ]).size
                                }{' '}
                                {formatText('myWallet-values')}
                            </span>
                            <span>
                                {' '}({totalTitles} {formatText(titlesLabel, [''])})
                            </span>
                        </p>
                        {seeDetailsButton}
                    </div>
                </section>
            );
        }

        if (
            immTransferValues.getIn(['steps', 1, BROKER_TRANSFER_VALUES_TYPE_PARTIAL, 'selected'])
        ) {
            const immTitles = immTransferValues.getIn(['steps', 1, 'titles']);

            const valueId = immTransferValues.getIn([
                'steps',
                1,
                BROKER_TRANSFER_VALUES_TYPE_PARTIAL,
                'id'
            ]);
            const immValue = immContractValues.getIn([
                immContractFrom.get('walletNumber'),
                'byId',
                valueId
            ]);

            const titles = immTitles.get(valueId);
            const titlesLabelPostfix = titles !== 1 ? 's' : '';
            const titlesLabel = `broker-transferValuesSidebarThirdStepTitle${titlesLabelPostfix}`;

            return (
                <section className="broker-transfer-values-sidebar__values-list">
                    <div className="broker-transfer-values-sidebar__values-list-title">
                        <FormattedText value="broker-transferValuesSidebarThirdStepValuesToTransfer" />
                    </div>
                    <div className="broker-transfer-values-sidebar__value">
                        <div className="broker-transfer-values-sidebar__value-name">
                            {immValue.get('description')}
                        </div>
                        <div className="broker-transfer-values-sidebar__value-titles">
                            <FormattedText value={titlesLabel} injectedStrings={[titles]} />
                        </div>
                    </div>
                </section>
            );
        }
    }

    buildTransferValuesDateBlock() {
        const dateLabel = DateHelper.buildFormattedDate(moment(), DATETIME_FORMAT_ES);

        return (
            <section>
                <FormattedText value="broker-transferValuesSuccessDate" />
                <div className="broker-transfer-values-sidebar__date">
                    {dateLabel}
                </div>
            </section>
        );
    }

    handleSeeTransferDetailsClick() {
        this.setState(currentState => ({
            modalOpen: !currentState.modalOpen
        }));
    }

    render() {
        const { immTransferValues, immStocksContracts, success } = this.props;
        const currentStep = immTransferValues.get('visibleStep');
        let block, content, detailsModal;

        if (immStocksContracts.size > 0) {
            detailsModal = this.buildDetailsModal();
        }

        if (!success) {
            switch (currentStep) {
                case 1:
                    block = this.buildFirstStepSidebar();
                    break;
                case 2:
                    block = this.buildSecondStepSidebar();
                    break;
                case 3:
                    block = this.buildThirdStepSidebar();
                    break;
            }

            content = (
                <OKSectionBox title={block.title}>
                    {detailsModal}
                    {block.content}
                </OKSectionBox>
            );
        } else {
            content = (
                <div>
                    {this.buildSuccessInfoBlock()}
                </div>
            );
        }

        return content;
    }
}

BrokerTransferValuesSidebar.propTypes = {
    immTransferValues: PropTypes.object.isRequired,
    immContractValues: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired,
    success: PropTypes.bool
};

BrokerTransferValuesSidebar.defaultProps = {
    success: false
};

module.exports = BrokerTransferValuesSidebar;
